import { render, staticRenderFns } from "./property-detail-proxy.vue?vue&type=template&id=1203fa4f&scoped=true&"
import script from "./property-detail-proxy.vue?vue&type=script&lang=js&"
export * from "./property-detail-proxy.vue?vue&type=script&lang=js&"
import style0 from "./property-detail-proxy.vue?vue&type=style&index=0&id=1203fa4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203fa4f",
  null
  
)

export default component.exports